import { create } from 'zustand';

export interface ToastMessage {
    id: string;
    message: string;
    type: 'success' | 'error' | 'info';
    image?: string;
}

interface UIState {
    isMobileMenuOpen: boolean;
    isCartOpen: boolean;
    isChatOpen: boolean;
    isSearchOpen: boolean;
    activeModal: string | null;
    modalData: Record<string, unknown> | null;
    isNavbarSolid: boolean;
    activeToast: ToastMessage | null;

    openMobileMenu: () => void;
    closeMobileMenu: () => void;
    toggleMobileMenu: () => void;
    openCart: () => void;
    closeCart: () => void;
    toggleCart: () => void;
    openChat: () => void;
    closeChat: () => void;
    toggleChat: () => void;
    openSearch: () => void;
    closeSearch: () => void;
    openModal: (modalId: string, data?: Record<string, unknown>) => void;
    closeModal: () => void;
    setNavbarSolid: (solid: boolean) => void;
    closeAll: () => void;
    showToast: (message: string, type?: 'success' | 'error' | 'info', image?: string) => void;
    hideToast: () => void;
}

export const useUIStore = create<UIState>()((set) => ({
    isMobileMenuOpen: false,
    isCartOpen: false,
    isChatOpen: false,
    isSearchOpen: false,
    activeModal: null,
    modalData: null,
    isNavbarSolid: false,
    activeToast: null,

    openMobileMenu: () => set({ isMobileMenuOpen: true }),
    closeMobileMenu: () => set({ isMobileMenuOpen: false }),
    toggleMobileMenu: () => set((s) => ({ isMobileMenuOpen: !s.isMobileMenuOpen })),

    openCart: () => set({ isCartOpen: true }),
    closeCart: () => set({ isCartOpen: false }),
    toggleCart: () => set((s) => ({ isCartOpen: !s.isCartOpen })),

    openChat: () => set({ isChatOpen: true }),
    closeChat: () => set({ isChatOpen: false }),
    toggleChat: () => set((s) => ({ isChatOpen: !s.isChatOpen })),

    openSearch: () => set({ isSearchOpen: true }),
    closeSearch: () => set({ isSearchOpen: false }),

    openModal: (modalId: string, data?: Record<string, unknown>) =>
        set({ activeModal: modalId, modalData: data ?? null }),
    closeModal: () => set({ activeModal: null, modalData: null }),

    setNavbarSolid: (solid: boolean) => set({ isNavbarSolid: solid }),

    closeAll: () =>
        set({
            isMobileMenuOpen: false,
            isCartOpen: false,
            isChatOpen: false,
            isSearchOpen: false,
            activeModal: null,
            modalData: null,
        }),

    showToast: (message, type = 'success', image) => {
        const id = Math.random().toString(36).substring(7);
        set({ activeToast: { id, message, type, image } });
        setTimeout(() => {
            set((s) => (s.activeToast?.id === id ? { activeToast: null } : s));
        }, 3000);
    },
    hideToast: () => set({ activeToast: null }),
}));
